module.exports = import("/messages-ui/assets/remoteEntry.js");